import { motion } from "framer-motion";

const CapitalDeMarca = () => {
  return (
    <section className="py-24 md:py-32 relative overflow-hidden bg-background">
      <div className="container px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto text-center"
        >
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold mb-10 text-foreground leading-tight tracking-tight">
            CAPITAL DE <span className="text-gradient-gold">MARCA</span>
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-foreground/80 leading-relaxed">
            <p>
              Una marca no es solamente identidad, comunicación o reputación.
            </p>
            <p className="text-foreground font-medium">
              Es un activo estratégico capaz de hacer perceptible el valor de una empresa.
            </p>
            <p>
              Cuando existe una brecha entre{" "}
              <span className="text-foreground font-medium">lo que la empresa vale</span>{" "}
              y{" "}
              <span className="text-foreground font-medium">lo que el mercado reconoce</span>,
              {" "}existe Capital de Marca por construir.
            </p>
            <p className="text-gradient-gold font-display font-medium text-xl md:text-2xl pt-4">
              Nuestro trabajo es cerrar esa brecha.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CapitalDeMarca;
